export enum PixelEvents {
    CAPITOL_3 = 'CAPITOL_3',
    CAPITOL_5 = 'CAPITOL_5',
    CAPITOL_7 = 'CAPITOL_7',
    HERO_4 = 'HERO_4',
    HERO_5 = 'HERO_5',
    HERO_6 = 'HERO_6',
    HERO_UPGRADE = 'HERO_UPGRADE',
    INSTALL = 'install',
    MARCHES_9 = 'MARCHES_9',
    MONSTER_LVL_5 = 'MONSTER_LVL_5',
    TUTOR_FINISH = 'tutor_finish',
    UNITS_TRAIN_SILVER_10000 = 'UNITS_TRAIN_SILVER_10000',
    VALOR_MONSTER_1000 = 'VALOR_MONSTER_1000',
    REGISTRATION_COMPLETE = 'REGISTRATION_COMPLETE',
    PURCHASE = 'PURCHASE',
    CLICKS_100 = '100_CLICKS',
    VALOR_MONSTER_1000_PER_MARCH = 'VALOR_MONSTER_1000_PER_MARCH',
}
